import React from 'react';
import Header from '../../components/header/index';
import Footer from '../../components/footer/index';
import http from '../../http/http';
import { Row, Col, Pagination, Empty, Tabs, message } from 'antd';
import global from '../../http/common';
import './index.css';
import case_placeholder from '../../static/imgs/case_placeholder.png';

const { TabPane } = Tabs;
class Case extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      arrs: [{
        title: "用户分享案例",
        data: [],
        tabValue: "推荐"
      }],
      totalCnt: 10,
      pageSize: 12,//每页显示条数
      pageNo: 1
    }
  }
  componentDidMount () {
    for (let i = 0; i < this.state.arrs.length; i++) {
      this.requestCaseList((i + 1) + "", "0", (dataArr) => {
        let map = {
          title: this.state.arrs[i].title,
          data: dataArr
        }
        let newArr = this.state.arrs
        newArr.splice(i, 1, map);
        this.setState({
          arrs: newArr
        });
      });
    }
  }
  requestCaseList (kindNo, orderType, callback) {
    //kindNo 0表示教程案例 1表示用户分享案例
    //orderType 0推荐 1表示最新
    http.get("/public/api/productCases", {
      kindNo: kindNo,
      orderType: orderType,
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize
    }, response => {
      if (response && response.result && response.result.length) {
        let dataArr = response.result;
        console.log(dataArr);
        if (dataArr && dataArr.length) {
          let resultArr = [];
          for (let i = 0; i < dataArr.length; i++) {
            let map = dataArr[i];
            map.previewUrl = http.hostUrl + http.contextName + map.previewUri;
            map.frontCoverUrl = http.hostUrl + http.contextName + map.frontCoverUri;
            resultArr.push(map);
            // resultArr.push(map);
            // resultArr.push(map);
            // resultArr.push(map);
          }
          callback(resultArr);
        }
      }
    });
  }
  render () {
    return (
      <div className='index_wrap noscrollbar' style={{ width: "100%", height: "100%", position: "absolute", left: "0px", top: "0px" }}>
        <div>
          <Header index="2"></Header>
          <div className="case_content box-padding-vertical">
            {
              this.state.arrs.map((data, index) => {
                let contentItem = (
                  <Row gutter={[16, 16]} className="content box-padding-horizontal-news" >
                    {
                      data.data.map((map, subIndex) => {
                        let frontCoverUrl = case_placeholder;
                        if (map.frontCoverUrl && map.frontCoverUrl != "") {
                          frontCoverUrl = map.frontCoverUrl;
                        }
                        return (
                          <Col md={8} xs={24} sm={12} lg={8} xl={6} key={"demo_item" + subIndex}>
                            <div className="col" onClick={this.lookBtnClick.bind(this, map)}>
                              <div className="demo_item">
                                <img className="img" style={{ width: "100%", height: "auto" }} src={frontCoverUrl}></img>
                                <div className="bottom">
                                  <div className="title">{map.productName}</div>
                                  <div className="version">{"v1.0.0"}</div>
                                  <div className="time">{map.sharedTime.split(" ")[0]}</div>
                                </div>
                              </div>
                            </div>
                          </Col>
                        )
                      })
                    }
                  </Row>
                )
                if (!data.data.length) {
                  contentItem = (
                    <div className="content" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <Empty description="暂无数据" style={{ color: "var(--light_text_color)" }} />
                    </div>
                  )
                }
                return (
                  <div className="content_item" style={{ marginBottom: index < this.state.arrs.length - 1 ? "20px" : "0px" }} key={"content_item" + index}>
                    <div className="title l_text">{data.title}</div>
                    <div className="control box-padding-horizontal">
                      <div className="control_item">
                        <Tabs defaultActiveKey="1" onChange={this.tabButtonClick.bind(this)}>
                          <TabPane tab="推荐" key="推荐_0">
                          </TabPane>
                          {/* <TabPane tab="最新" key="最新_0">
                          </TabPane> */}
                        </Tabs>
                      </div>
                    </div>
                    {
                      contentItem
                    }
                    <Pagination defaultCurrent={1} total={this.state.totalCnt} pageSize={this.state.pageSize} style={{ marginTop: "30px" }} onChange={this.paginationOnChange.bind(this)}></Pagination>
                  </div>
                );
              })
            }
          </div>
          <Footer></Footer>
        </div>
      </div>
    );
  }
  paginationOnChange (page, pageSize) {
    console.log(page + " " + pageSize);
    this.setState({
      pageNo: page
    }, () => {
      this.requestCaseList("0", this.state.arrs[0].tabValue == "推荐" ? "0" : "1", (dataArr) => {
        let map = {
          title: this.state.arrs[0].title,
          data: dataArr
        }
        let newArr = this.state.arrs
        newArr.splice(0, 1, map);
        this.setState({
          arrs: newArr
        });
      });
    });
  }
  lookBtnClick (data) {
    console.log(data);
    var isLogin = global.isLogin();
    if (global.isPhone()) {
      message.info('暂时只支持电脑端打开编辑器，快去尝试下吧~');
    } else {
      if (isLogin) {
        window.lookProductBtnClick(data);//已经登录 直接进入
      } else {
        window.visitorLoginBtnClick(function () {
          window.lookProductBtnClick(data);
        });//未登录 游客登录进入
      }
    }
  }
  lookAllBtnClick () {
    var isLogin = global.isLogin();
    if (isLogin) {
      window.hrefProductHome();//已经登录 直接进入
    } else {
      window.visitorLoginBtnClick();//未登录 游客登录进入
    }
  }
  tabButtonClick (key) {
    if (key) {
      var arr = key.split("_");
      if (arr && arr.length) {
        this.requestCaseList("0", arr[0] == "推荐" ? "0" : "1", (dataArr) => {
          let map = {
            title: this.state.arrs[0].title,
            data: dataArr,
            tabValue: arr[0]
          }
          let newArr = this.state.arrs
          newArr.splice(0, 1, map);
          this.setState({
            arrs: newArr
          });
        });
      }
    }
  }
}
export default Case;